'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _IssuePage = require('./IssuePage.css');

var _IssuePage2 = _interopRequireDefault(_IssuePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IssuePrisonIndustrialComplex = (_dec = (0, _reactCssModules2.default)(_IssuePage2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(IssuePrisonIndustrialComplex, _Component);

  function IssuePrisonIndustrialComplex(props) {
    (0, _classCallCheck3.default)(this, IssuePrisonIndustrialComplex);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IssuePrisonIndustrialComplex.__proto__ || (0, _getPrototypeOf2.default)(IssuePrisonIndustrialComplex)).call(this, props));

    _this.state = {
      title: 'The issue: Prison industrial complex',
      description: 'Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation.',
      url: _config2.default.domain + _config2.default.routes.issuePrisonIndustrialComplex
    };
    return _this;
  }

  (0, _createClass3.default)(IssuePrisonIndustrialComplex, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'page issue-pff' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              'h1',
              { styleName: 'issue-top-label' },
              'The issue: ',
              _react2.default.createElement(
                'span',
                null,
                'Prison industrial complex'
              )
            ),
            _react2.default.createElement(
              'h2',
              { styleName: 'issue-top-headline' },
              'Mass incarceration is a manifestation of racist policy'
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'issue-top-copy' },
              'Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation.'
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 4 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-headline' },
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'nowrap' } },
                    '\u2014\u2014\u2014\u2014'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'h2',
                    null,
                    'Retirement plans are invested in private prison operators and other high-risk companies'
                  )
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 8 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-copy' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Mass incarceration is particularly devastating for poor communities, immigrants, people of color, and their families. For-profit firms have flooded money into prison and immigration jail infrastructure and services, and have used industry associations to lobby for harsher policing and longer sentencing, even for non-violent offenders. People who are incarcerated work for pennies per hour while their families pay exorbitant fees to keep them supplied with bare necessities. Powerful, private equity interests and corporations reap enormous profits from the militarization of the U.S.-Mexico border and the policing of immigration.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Asset managers like Vanguard are investing in economic systems of oppression and exploitation \u2013 and they\u2019re using workers\u2019 retirement plan savings to do so. Through Vanguard, the retirement plans of companies like Amazon and Comcast are investing hundreds of millions of dollars into private prison operators and other companies recommended for divestment by the ',
                    _react2.default.createElement(
                      _components.Link,
                      { to: _config2.default.links.afscInvestigate, title: 'American Friends Service Committee state violence criteria', xstrong: true },
                      'American Friends Service Committee state violence criteria.'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement('div', { styleName: 'img-issue' })
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'issue-focus-label' },
                    'FOCUS: SUSTAINABILITY RISK'
                  ),
                  _react2.default.createElement(
                    'h3',
                    { styleName: 'issue-focus-headline' },
                    'Private prison operators'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Cities, counties, states, and the federal government sometimes contract with for-profit private contractors to operate prisons, jails, and immigration jails. Corporate retirement plans have hundreds of millions of dollars invested in private prison operators like U.S.-based GEO Group and CoreCivic, British company Serco, and French company Sodexo.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'These private prison corporations spend substantial money on lobbying and campaign contributions to secure contracts and promote legislation that results in higher rates of incarceration. For many of these contracts, the companies are paid based upon how many beds are occupied in any given facility, incentivizing the company to support incarcerating more people.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.companies + '#prisonindustrialcomplex',
                          title: 'Companies: Prison industrial complex',
                          xstrong: true
                        },
                        'Learn more',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'section-solutions-faq-background' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'section',
              { styleName: 'section section-solutions-faq' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'h2',
                      { styleName: 'issue-solutions-label' },
                      'The Solutions'
                    ),
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'issue-solutions-headline' },
                      'Exclude high-risk prison industrial complex companies from retirement plan default options'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-solutions-copy' },
                      _react2.default.createElement(
                        'p',
                        null,
                        'The default option offered in company retirement plans, which usually ends up with the bulk of employee contributions, should be sustainably invested and exclude companies with significant involvement in the prison industrial complex like private prison operators.'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.solutionDefaultSustainability,
                          title: 'Solution: Default to sustainability',
                          xstrong: true
                        },
                        'Explore solutions',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'h2',
                      { styleName: 'issue-faqs-label' },
                      'FAQs'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-headline' },
                      'Answers to common questions about how retirement plans and asset managers are financing the prison industrial complex.'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-',
                          title: 'Do I have to sacrifice returns in order to invest sustainably?',
                          xstrong: true
                        },
                        'Do I have to sacrifice returns in order to invest sustainably?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-',
                          title: 'Why should retirement plans add a sustainable investment option?',
                          xstrong: true
                        },
                        'Why should retirement plans add a sustainable investment option?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs,
                          title: 'FAQs',
                          xstrong: true
                        },
                        'View all >>'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          )
        )
      );
    }
  }]);
  return IssuePrisonIndustrialComplex;
}(_react.Component)) || _class);
exports.default = IssuePrisonIndustrialComplex;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/IssuePage/IssuePrisonIndustrialComplex.js
// module id = 1486
// module chunks = 0